
export default {
  data() {
    return {
      socialMidiaList: [
        {
          iconerede: 'fab fa-facebook-f',
          correde: '#4267B2',
          textorede: 'Facebook',
        },
        {
          iconerede: 'fab fa-linkedin-in',
          correde: '#0e76a8',
          textorede: 'LinkedIn',
        },
        {
          textorede: 'Telegram',
          iconerede: 'fab fa-telegram-plane',
          correde: '#0088cc',
        },
        {
          iconerede: 'fab fa-twitter',
          correde: '#00acee',
          textorede: 'Twitter',
        },
        {
          textorede: 'WhatsApp',
          iconerede: 'fab fa-whatsapp',
          correde: '#25d366',
        },
      ],
    }
  },
}
